
import Skeleton from '@/app/components/Skeleton.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({ components: { Skeleton } })
export default class MainLoading extends Vue {}
